// Motor de trato: convierte español rioplatense (voseo) -> español formal neutro (tuteo).
// Diccionario curado de formas de SEGUNDA PERSONA (voseo) para evitar falsos positivos
// con pretéritos de primera persona (olvidé, escuché, entendí, etc. NO se tocan).
// Base de la plataforma escrita en vos; se aplica solo cuando la variante de la empresa es "tu".

const MAP = {
  // pronombres / preposicionales (van antes que "vos" solo por longitud)
  "con vos": "contigo",
  "de vos": "de ti",
  "a vos": "a ti",
  "para vos": "para ti",
  "por vos": "por ti",
  "en vos": "en ti",
  "vos": "tú",
  // adverbios regionales
  "acá": "aquí",
  "allá": "allí",
  // ser
  "sos": "eres",
  // formas conjugadas (vos -> tú)
  "tenés": "tienes",
  "tené": "ten",
  "podés": "puedes",
  "querés": "quieres",
  "sabés": "sabes",
  "hacés": "haces",
  "hacé": "haz",
  "contás": "cuentas",
  "contá": "cuenta",
  "usás": "usas",
  "usá": "usa",
  "trabajás": "trabajas",
  "llamás": "llamas",
  "confirmás": "confirmas",
  "entrás": "entras",
  "entrá": "entra",
  "ponés": "pones",
  "poné": "pon",
  "seguís": "sigues",
  "seguí": "sigue",
  "venís": "vienes",
  "vení": "ven",
  "elegís": "eliges",
  "elegí": "elige",
  "preferís": "prefieres",
  "subís": "subes",
  "subí": "sube",
  "mirás": "miras",
  "mirá": "mira",
  "pará": "para",
  "pegás": "pegas",
  "pegá": "pega",
  "cargás": "cargas",
  "cargá": "carga",
  "empezás": "empiezas",
  "empezá": "empieza",
  "terminás": "terminas",
  "terminá": "termina",
  "descubrí": "descubre",
  "revisás": "revisas",
  "revisá": "revisa",
  "agregás": "agregas",
  "agregá": "agrega",
  "corregí": "corrige",
  "probás": "pruebas",
  "probá": "prueba",
  "tocás": "tocas",
  "tocá": "toca",
  "grabás": "grabas",
  "grabá": "graba",
  "creá": "crea",
  "completás": "completas",
  "completá": "completa",
  "sumás": "sumas",
  "sumá": "suma",
  "armás": "armas",
  "armá": "arma",
  "dejás": "dejas",
  "dejá": "deja",
  "volvés": "vuelves",
  "volvé": "vuelve",
  "cerrás": "cierras",
  "cerrá": "cierra",
  "abrís": "abres",
  "abrí": "abre",
  "escribís": "escribes",
  "escribí": "escribe",
  "mandás": "mandas",
  "mandá": "manda",
  "hablás": "hablas",
  "hablá": "habla",
  "guardás": "guardas",
  "guardá": "guarda",
  "llevá": "lleva",
  "decí": "di",
  "esperá": "espera",
  // imperativos con pronombre enclítico (vos -> tú)
  "contame": "cuéntame",
  "preguntame": "pregúntame",
  "preguntanos": "pregúntanos",
  "preguntale": "pregúntale",
  "contanos": "cuéntanos",
  "contale": "cuéntale",
  "mostrame": "muéstrame",
  "mostrámelo": "muéstramelo",
  "decime": "dime",
  "pegalo": "pégalo",
  "pegame": "pégame",
  "cargalo": "cárgalo",
  "llevátelo": "llévatelo",
  "guardátelo": "guárdatelo",
  "ponelo": "ponlo",
  "ponela": "ponla",
  "corregilo": "corrígelo",
  "mandame": "mándame",
  "mandanos": "mándanos",
  "fijate": "fíjate",
  "quedate": "quédate",
  "tomate": "tómate",
  "avisame": "avísame",
  "escuchame": "escúchame",
  "mirame": "mírame",
  "esperame": "espérame",
  "dejame": "déjame",
  "pasame": "pásame",
  "revisalo": "revísalo",
  "probalo": "pruébalo",
  "copialo": "cópialo",
  "aplicás": "aplicas",
  "copiás": "copias",
  "definís": "defines",
  "descargalo": "descárgalo",
  "sumalo": "súmalo",
};

function escapeRe(s) {
  return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

// claves ordenadas por longitud desc para que las frases ganen a las palabras sueltas
const KEYS = Object.keys(MAP).sort((a, b) => b.length - a.length);
let REGEX = null;
try {
  REGEX = new RegExp(
    "(?<![\\p{L}\\p{N}_])(" + KEYS.map(escapeRe).join("|") + ")(?![\\p{L}\\p{N}_])",
    "giu"
  );
} catch (e) {
  // Fallback sin lookbehind (navegadores viejos): usa límites simples.
  REGEX = new RegExp("\\b(" + KEYS.map(escapeRe).join("|") + ")\\b", "gi");
}

function aplicarCase(src, repl) {
  const soloLetras = src.replace(/[^\p{L}]/gu, "");
  if (soloLetras && soloLetras === soloLetras.toUpperCase() && soloLetras !== soloLetras.toLowerCase()) {
    return repl.toUpperCase();
  }
  if (src[0] && src[0] === src[0].toUpperCase() && src[0] !== src[0].toLowerCase()) {
    return repl[0].toUpperCase() + repl.slice(1);
  }
  return repl;
}

export function transformar(texto) {
  if (!texto || !REGEX) return texto;
  REGEX.lastIndex = 0;
  return texto.replace(REGEX, (m) => {
    const repl = MAP[m.toLowerCase()];
    if (repl == null) return m;
    return aplicarCase(m, repl);
  });
}
